import "#legacy/admin/autocomplete.js";

(function ($) {
  window.AdminSearch = function (searchContainer, options) {
    searchContainer = jQuery(searchContainer);

    var searchTypeSelector = "sp-select.scope_selector";
    var searches = searchContainer.find(searchTypeSelector);
    var queryInput = searchContainer.find(".query_input");
    var clearSearchInputFieldButton = searchContainer.find('[data-behavior="clear-search-input"]');
    var autocomplete = new Sparkle.SpotlightSearch(
      "",
      jQuery.extend({ input: queryInput, details: false, anchor: searchContainer }, options.spotlightOptions),
    );
    var searchParamSelector = ".search-param";
    var searchParamField = jQuery("<input>").attr({ type: "hidden", class: "search-param" });
    var form;
    var isSidewide = options.spotlightOptions && options.spotlightOptions.sidewide;

    if (options.form !== false) {
      form = searchContainer.closest("form");
      form.on("submit", disableSearchesInputParam);
    }

    // BEHAVIOUR / LISTENERS

    function handleScopeChange() {
      render();
      autocomplete.updateResults();
    }

    searchContainer.on("change", searchTypeSelector, handleScopeChange);

    function handleSelection(event, item) {
      if (options.selectCallback) {
        options.selectCallback(item, searchContainer);
      } else if (form) {
        setQuery(item.name);
        form.trigger("submit");
      }
    }

    jQuery(autocomplete).on("select", handleSelection);

    queryInput.on("input", handleChangeInput);
    clearSearchInputFieldButton.on("click", handleClearText);
    // EVENT HANDLERS

    function disableSearchesInputParam() {
      // params are not set via the searches input, see setSearchParams function
      searches.attr("disabled", true);
    }

    function queryValue() {
      return queryInput[0]?.value || "";
    }

    function setQuery(value) {
      if (queryInput[0]) {
        queryInput[0].value = value;
      }
    }

    function handleChangeInput() {
      toggleQueryInputClass(!!queryValue());
    }

    function handleClearText() {
      setQuery("");
      queryInput.focus();
      toggleQueryInputClass(!!queryValue());
    }

    function handleCloseModal() {
      jQuery('[data-behaviour="close-modal"]', ".admin-modal--search-spotlight").trigger("click");
    }

    function handleClearOrCancel() {
      queryValue() ? handleClearText() : handleCloseModal();
    }

    // HELPER FUNCTIONS

    function appendClearTextControl() {
      if (!isSidewide) {
        return;
      }

      jQuery(options.spotlightOptions.clearTextIcon).insertAfter(queryInput);
    }

    function appendCloseModalControl() {
      if (!isSidewide) {
        return;
      }

      jQuery(options.spotlightOptions.closeModalIcon).insertAfter(queryInput);
    }

    function addCancelControlListener() {
      jQuery(".icon-wrapper:last-child").on("click", handleClearOrCancel);
    }

    function toggleQueryInputClass(dirty) {
      searchContainer.toggleClass("--is-dirty", dirty);
    }

    function selectedScopeData() {
      var scope = searches[0];
      var items = scope?.items || JSON.parse(scope?.getAttribute("items") || "[]");
      var value = scope?.value ?? scope?.getAttribute("value");
      var selectedValue = Array.isArray(value) ? value[0] : value;
      var selected = items.find((item) => String(item.value) === String(selectedValue)) || items[0];

      return selected?.dataset || {};
    }

    function scopeSearchParams(data) {
      return typeof data.searchParams === "string" ? JSON.parse(data.searchParams) : data.searchParams;
    }

    function updateEndpoint(data) {
      autocomplete.setEndpoint(
        data.autocompleteUrl || options.autocompleteUrl || searchContainer.attr("autocomplete_url"),
      );
    }

    function updateForm(data) {
      if (!form) {
        return;
      }

      setSearchParams(scopeSearchParams(data));
      form.attr("action", data.searchUrl || form.attr("action"));
    }

    function renderSpotlightControls() {
      if (!isSidewide) {
        return;
      }

      appendClearTextControl();
      appendCloseModalControl();
      addCancelControlListener();
    }

    function render() {
      var data = selectedScopeData();
      updateEndpoint(data);
      searchContainer.toggleClass("--active", Boolean(queryValue()));
      updateForm(data);
      renderSpotlightControls();
    }

    function setSearchParams(params) {
      form.find(searchParamSelector).remove();

      jQuery.each(params, function (key, value) {
        searchParamField.attr({ name: key, value: value }).appendTo(form);
      });
    }

    // INITIALIZE

    render();
    autocomplete.render();
  };
})(jQuery);
